import GenericPendingExitRequests from "../GenericPendingExitRequests/GenericPendingExitRequests";
import { ALL_EXIT_REQUESTS_REG, ALL_EXIT_REQUESTS_EXPORT } from "@API/APIRoutes";

function AllPendingExitRequestsListing() {
  return <GenericPendingExitRequests API={ALL_EXIT_REQUESTS_REG} exportApi={ALL_EXIT_REQUESTS_EXPORT}  title = {"Regulatory Ingredients Hub"} all ={true} readOnly ={false}/>;
}

export default AllPendingExitRequestsListing;
